// extracted by mini-css-extract-plugin
export default {"container":"DeleteAccount_container__3Sg6N"};